module.exports = __webpack_public_path__ + "assets/img/tag-treasure-e09015fa.png";